import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ProfetControlWidgetModule } from 'src/app/module/profet-control-widget/profet-control-widget.module';
import { PropertyConfig } from 'src/app/shared/config/property.config';

export interface UnitCountDialogData {
  currentUnitCount: number;
}

@Component({
  selector: 'app-unit-count-dialog',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, ProfetControlWidgetModule, ReactiveFormsModule],
  templateUrl: './unit-count-dialog.component.html',
  styleUrls: ['./unit-count-dialog.component.scss'],
})
export class UnitCountDialogComponent {
  readonly minUnitCount = PropertyConfig.multifamilyMinUnitCount;
  readonly maxUnitCount = PropertyConfig.multifamilyMaxUnitCount;
  unitCountForm: FormGroup;

  constructor(
    private _fb: FormBuilder,
    public dialogRef: MatDialogRef<UnitCountDialogComponent, number>,
    @Inject(MAT_DIALOG_DATA) public data: UnitCountDialogData
  ) {
    dialogRef.disableClose = true;
    this.unitCountForm = this._fb.group({
      unitCount: [this._resolveInitialUnitCount(), [Validators.required]],
    });
  }

  createUnits(): void {
    if (this.unitCountForm.invalid) return;

    this.dialogRef.close(Number(this.unitCountForm.value.unitCount));
  }

  cancel(): void {
    this.dialogRef.close();
  }

  /**
   * Seeds the form with the property's existing unit count, clamped into the allowed range.
   * profet-input attaches its min/max validators after the view is checked, so starting on an
   * out-of-range value would flip validity mid-cycle and trip ExpressionChangedAfterItHasBeenChecked.
   */
  private _resolveInitialUnitCount(): number {
    const clampedToMinimum = Math.max(this.data.currentUnitCount, this.minUnitCount);

    return Math.min(clampedToMinimum, this.maxUnitCount);
  }
}
